import { render, staticRenderFns } from "./AppointmentAsked.vue?vue&type=template&id=67356430&scoped=true"
import script from "./AppointmentAsked.vue?vue&type=script&lang=js"
export * from "./AppointmentAsked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67356430",
  null
  
)

export default component.exports